import style from "./Footer.module.css";

const Footer = () => {
  return (
    <footer className={style.footer}>
      <p>© 2024 Marco Di Summa</p>
    </footer>
  );
};
export default Footer;
